import { Router } from '@angular/router';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Account } from './../models/account';
import { Auth } from './../Auth';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AutenticationEventType } from '../autentication.event.type';
import { TweenMax, Quint, Power2, Sine } from 'gsap';
import { AutenticationService } from '../autentication.service';
import { EventTypes } from '../../shared/EventTypes';
import { User } from '../models/user';
import { AuthMessage } from '../models/auth-message';
import { AppConfig } from '../../AppConfig';
import * as moment from 'moment';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ThemeService } from '../../shared/theme-service/theme.service';

@Component({
	selector: 'app-attendant-auth',
	templateUrl: './attendant-auth.component.html',
	styleUrls: ['./attendant-auth.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class AttendantAuthComponent implements OnInit, OnDestroy {

	corTextoBotaoDesabilitado: any;
	corBotaoDesabilitado: any;
	formLogin: FormGroup;
	cpf: string;
	canSend = false;
	sending = false;
	active = false;
	scrollHeight = 180;
	disabled = false;

	constructor(
			private router: Router,
			private authService: AutenticationService,
			private formBuilder: FormBuilder,
			private themeService: ThemeService,
		) {
		this.formLogin = formBuilder.group({
			'cpf': [null, Validators.required],
			'pass': ['', Validators.required]
		});
	}


	ngOnInit() {
		AppEventDispatcher.listen(AutenticationEventType.ATTENDANT.ATTENDANT_AUTH, (data) => {
			this.active = true;
			this.show(data);
		});

		if (this.themeService.themeConfigs) {
			this.corBotaoDesabilitado = this.themeService.CorBotaoDesabilitado ? this.themeService.CorBotaoDesabilitado : '';
			this.corTextoBotaoDesabilitado = this.themeService.CorTextoBotaoDesabilitado ? this.themeService.CorTextoBotaoDesabilitado : '';
		}
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.ATTENDANT.ATTENDANT_AUTH);
	}

	verifyForm() {
		if ((this.formLogin.controls.cpf.value.length >= 11) && (this.formLogin.controls.pass.value.length >= 6)) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}
	}


	send() {


		if ( !this.sending && this.canSend && this.formLogin.valid ) {
			this.sending = true;

			this.authService.getUserAttendant(this.formLogin.value.cpf, this.formLogin.value.pass).subscribe((retorno: boolean) => {
				this.sending = false;
				if (retorno) {
					Auth.getInstance().setAttendantLogged(retorno);
					this.router.navigate(['servico-de-atendimento']);
				} else {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Dados Inválidos!' });
					this.sending = false;
				}
			}, error => {
				this.sending = false;
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
					msg: navigator.onLine ? error.error ? error.error.Mensagem : 'Erro inesperado. Favor tentar novamente' : 'Você está sem conexão com internet. Por favor, tente novamente mais tarde' });
			});
		}

	}

	show(data) {

		const interval = setInterval(() => {

			if ($('[data-component="attendant-auth"]').length > 0) {

				clearInterval(interval);

				if (data.direction === 'LEFT_TO_RIGHT') {
					TweenMax.set('[data-component="attendant-auth"]', {left: '-150%'});
				}
				TweenMax.to('[data-component="login"]', .8, { height: 550, ease: Sine.easeOut});
				TweenMax.to('[data-component="attendant-auth"]', .8, {delay: data.delay, left: '50%', ease: Quint.easeOut});
			}

		}, 10);

	}

	hide(active, toRigh = false) {


		if (toRigh) {
			TweenMax.to('[data-component="attendant-auth"]', 1.2, {left: '150%', ease: Quint.easeOut});
		} else {
			TweenMax.to('[data-component="attendant-auth"]', 1.6, {left: '-100%', ease: Quint.easeOut});
		}

		TweenMax.delayedCall(.6, () => {
			this.active = active;
			this.canSend = false;
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/attendant-auth/attendant-auth.component.ts